import  { useState } from 'react';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = (e: any) => {
    e.preventDefault();

    // Make a POST request to the PHP backend
    fetch('https://akjodem.com/login.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, password }),
      credentials: 'include', // Include session cookies
    })
      .then(response => response.json())
      .then(data => {
        if (data.status === 'success') {
          localStorage.setItem('akjodem_email', data.email);
          localStorage.setItem('akjodem_isLoggedIn', 'true');
          setMessage('Login successful!');
          // Redirect to protected page
          window.location.href = '/admin/dashboard';
        } else {
          setMessage(data.message);
          console.log(data.message)
        }
      })
      .catch(error => {
        console.error('Error:', error);
        setMessage('An error occurred.');
      });
  };

  return (
    <div className="flex justify-center items-center bg-gray-100 min-h-screen">
      <div className="bg-white shadow-md p-6 rounded-lg w-full max-w-sm">
        <h2 className="mb-6 font-bold text-gray-800 text-2xl text-center">Admin Login</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block mb-2 font-medium text-gray-700 text-sm">Username:</label>
            <input
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
            />
          </div>
          <div className="mb-6">
            <label className="block mb-2 font-medium text-gray-700 text-sm">Password:</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
            />
          </div>
          <button
            type="submit"
            className="bg-blue-600 hover:bg-blue-700 px-4 py-2 rounded-lg w-full text-white transition-colors"
          >
            Login
          </button>
        </form>
        {message && <p className="mt-4 text-red-600 text-center">{message}</p>}
      </div>
    </div>

  );
}

export default Login;
